import { DetailQueryMeeting } from "@/types/meetings";

export const BALANCE_NOT_ENOUGH = "Balance Not Enough";
export const RESCHEDULE_FAIL = "Reschedule Fail. Please contact support";

export const isMeetingRefundable = (meeting?: DetailQueryMeeting | null) => {
  if (!meeting) return false;
  if (!meeting.refundableUntil) return false;
  const refundableUntil = new Date(meeting.refundableUntil);
  return refundableUntil > new Date();
};
